/** Dispatched by any Apply CTA; Header listens and opens the leave-site popup. */
export const OPEN_APPLY_MODAL_EVENT = 'vibesite:open-apply-modal';

export function requestOpenApplyModal(e?: { preventDefault?: () => void }) {
  e?.preventDefault?.();
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_APPLY_MODAL_EVENT));
}
